import { render, staticRenderFns } from "./SetAlarm.vue?vue&type=template&id=b025d6ba&scoped=true&"
import script from "./SetAlarm.vue?vue&type=script&lang=js&"
export * from "./SetAlarm.vue?vue&type=script&lang=js&"
import style0 from "./SetAlarm.vue?vue&type=style&index=0&id=b025d6ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b025d6ba",
  null
  
)

export default component.exports